import { render } from "./ContentHeaderSection.vue?vue&type=template&id=7c8ffe17&scoped=true"
import script from "./ContentHeaderSection.vue?vue&type=script&lang=js"
export * from "./ContentHeaderSection.vue?vue&type=script&lang=js"

import "./ContentHeaderSection.vue?vue&type=style&index=0&id=7c8ffe17&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8ffe17"]])

export default __exports__